import { CSSProperties, FC, ReactNode } from 'react'
import cn from './index.module.css'
import classNames from 'classnames'

interface IFieldWrapper {
  label?: string
  description?: string
  children: ReactNode
  extraContent?: ReactNode
  isInvalid?: boolean
  className?: string
  styles?: CSSProperties
}

const FieldWrapper: FC<IFieldWrapper> = ({
  children,
  label,
  description,
  isInvalid,
  extraContent,
  className,
  styles,
}) => {
  return (
    <div className={classNames(cn.wrapper, className)} style={styles}>
      {(label || extraContent) && (
        <div className={cn.header}>
          <span className={classNames(cn.label, isInvalid && cn.invalid)}>
            {label}
          </span>
          {extraContent}
        </div>
      )}
      {children}
      {description && <span className={cn.description}>{description}</span>}
    </div>
  )
}

export default FieldWrapper
